export default __webpack_public_path__ + "media/images/durable-image.jpg";